<template>
  <Field :label="label" :isRequired="isRequired">
    <input class="input" :type="type" :placeholder="placeholder" :value="value" @input="$emit('input', $event)" />
  </Field>
</template>

<script>
import Field from './Field';

export default {
  name: 'InputField',
  components: {
    Field
  },
  props: {
    label: String,
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: String,
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};
</script>
